/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RevertEditDowntimeEntry } from '../../models/revert-edit-downtime-entry';

export interface RevertEditDowntime$Params {
  downtimeId: number;
      body: RevertEditDowntimeEntry
}

export function revertEditDowntime(http: HttpClient, rootUrl: string, params: RevertEditDowntime$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, revertEditDowntime.PATH, 'post');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

revertEditDowntime.PATH = '/api/v1/Downtimes/{downtimeId}/RevertEditDowntime';
